import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInputClass;
function GrantDiscordAccessInput() {
  if (GrantDiscordAccessInputClass === VOID) {
    class $ {
      constructor(code, partyId, guildId) {
        this.v6m_1 = code;
        this.w6m_1 = partyId;
        this.x6m_1 = guildId;
      }
      toString() {
        return 'GrantDiscordAccessInput(code=' + this.v6m_1 + ', partyId=' + this.w6m_1.toString() + ', guildId=' + this.x6m_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.v6m_1);
        result = imul(result, 31) + this.w6m_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.x6m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessInput()))
          return false;
        if (!(this.v6m_1 === other.v6m_1))
          return false;
        if (!this.w6m_1.equals(other.w6m_1))
          return false;
        if (!(this.x6m_1 === other.x6m_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessInput');
    GrantDiscordAccessInputClass = $;
  }
  return GrantDiscordAccessInputClass;
}
//region block: exports
export {
  GrantDiscordAccessInput as GrantDiscordAccessInputqu7hxtlblgwv,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput.mjs.map
